// extracted by mini-css-extract-plugin
export default {"validity":"styles_validity__Ow+fg","sourceField":"styles_sourceField__UA3Kt","label":"styles_label__4Hp-K","sourceInput":"styles_sourceInput__YxU+J"};